// ### LoginWindow
//
// Watches Adobe's new-tab-or-window-login window.

'use strict';

var App = require('./app');
var _logger = require('./logger');
var SimpleEmitter = require('./emitter');
var WindowWatcher = require('./windowwatcher');


var loginWindow = new WindowWatcher(App.ADOBE_WINDOW_NAME);

function onOpened() {
	/* jshint validthis:true */

	_logger.log('LoginWindow - onOpened');

	if (!loginWindow.window) {
		window.alert('Pop-up blocker may have prevented the login window from opening.');
		return;
	}

	this.emit('opened');
}

function onClosed() {
	/* jshint validthis:true */

	_logger.log('LoginWindow - onClosed');

	this.emit('closed');
}

function open(mvpd, options, origin) {
	_logger.log('LoginWindow - open');

	loginWindow.open(origin);
}

function close() {
	_logger.log('LoginWindow - close');

	loginWindow.close();
}

function isOpened() {
	return loginWindow.isOpened();
}

function setSrc(url) {
	return loginWindow.setSrc(url);
}

var emitter = SimpleEmitter.mixin({
	isOpened : isOpened,
	setSrc : setSrc,
	open : open,
	close : close
});

loginWindow.on('opened', onOpened, emitter);
loginWindow.on('closed', onClosed, emitter);


module.exports = emitter;
